import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      authToken
      resetToken
    }
  }
`;

export const FORGOT_PASSWORD_MUTATION = gql`
mutation Mutation($email: String!, $locale: String!) {
  forgotPassword(email: $email, locale: $locale)
}
`;

export const RESET_PASSWORD_MUTATION = gql`
    mutation ResetPassword($resetToken: String!, $password: String!, $confirmPassword: String!) {
      resetPassword(resetToken: $resetToken, password: $password, confirmPassword: $confirmPassword)
     }
  `;
